<template>
    <div>

        <a name="code-example-php"></a>
        <h1>PHP</h1>
<div v-highlight><pre class="language-php"><code>
&lt;?php

$shop_id = 123456;
$api_token = 'AAABBBCCCDDDEEEFFFGGGHHHIIIJJJKKK';

$payload = array(
    "pagination_offset" => 0,
    "pagination_limit" => 10,
);

$ch = curl_init();
curl_setopt($ch, CURLOPT_URL,"https://open.lnwshop.com/{$shop_id}/api/v1/order/list");
curl_setopt($ch, CURLOPT_POST, 1);
curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($payload));
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
curl_setopt($ch, CURLOPT_HTTPHEADER, array(
    "X-API-KEY: {$api_token}",
    "Content-Type: application/json"
));

$response = curl_exec($ch);
$error = curl_error($ch);
curl_close($ch);

if (!empty($error)) {
    echo "Error: {$error}";
    return;
}

$data = json_decode($response, true);

</code></pre></div>

        <a name="code-example-nodejs"></a>
        <h1>Node.js</h1>
<div v-highlight><pre class="language-js"><code>
const shop_id = 123456;
const api_token = 'AAABBBCCCDDDEEEFFFGGGHHHIIIJJJKKK';

const payload = JSON.stringify({
    "pagination_offset": 0,
    "pagination_limit": 10,
})

const https = require('https');

const options = {
  hostname: "open.lnwshop.com",
  port: 443,
  path: '/'+ shop_id + '/api/v1/order/list',
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': api_token,
    'Content-Length': payload.length,
  },
}

const req = https.request(options, (resp) => {
  let data = '';

  // A chunk of data has been received.
  resp.on('data', (chunk) => {
    data += chunk;
  });

  // The whole response has been received. Print out the result.
  resp.on('end', () => {
    // output
    data = JSON.parse(data)
    console.log(data);
  });

}).on("error", (err) => {
  console.log("Error: " + err.message);
});

req.write(payload)
req.end()

</code></pre></div>

    </div>
</template>

<script>
    export default {
        name: "CodeExamples"
    }
</script>

<style scoped>

</style>